<template>
  <div
    class="bug-list"
    ref="bugListRef"
    @mouseenter="mouseBtn('moveIn')"
    @mouseleave="mouseBtn('remove')"
  >
    <div class="bug-item" :class="{'bug-item-alarm': !item.statisticsType}" v-for="(item, index) in alarmList" :key="index">
      <div class="bug-left">
        <template v-if="item.statisticsType">
          <div class="bug-title"><div class="bug-text">缺陷描述</div></div>
        </template>
        <template v-else>
          <div class="bug-title">
            <div class="bug-text">{{ item.alarmType === 'DCSThresholdAlarmRecord' ? 'DCS预警': '趋势预警' }}</div>
          </div>
        </template>
        <div class="bug-desc">{{ item.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'bugInfo',
  props: {
    alarmList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    alarmList() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      this.$nextTick(() => {
        this.autoScroll()
      })
    },
  },
  data() {
    return {
      scrollDirection: 'down', // 滚动方向 up向上 down向下
      scrollTimer: null,
    }
  },
  methods: {
    autoScroll() {
      const dom = this.$refs.bugListRef
      if (dom) {
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        if (scrollHeight - clientHeight <= 0) return
        this.scrollFun()
      }
    },
    scrollFun() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      this.scrollTimer = setInterval(() => {
        const dom = this.$refs.bugListRef
        if (!dom) {
          clearInterval(this.scrollTimer)
          return
        }
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        const scrollTop = dom.scrollTop
        // 向下滚动
        if (this.scrollDirection === 'down') {
          dom.scrollTop = scrollTop + 1
          if (scrollHeight - clientHeight <= scrollTop + 1) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'up'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
          // 向上滚动
        } else if (this.scrollDirection === 'up') {
          dom.scrollTop = scrollTop - 1
          if (scrollTop - 1 <= 0) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'down'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
        }
      }, 150)
    },
    bugRegisterHandle(row) {
      this.$emit('bugRegisterHandle', row)
    },
    mouseBtn(type) {
      if (type === 'moveIn') {
        if (this.scrollTimer) {
          clearInterval(this.scrollTimer)
          this.scrollTimer = null
        }
      } else if (type === 'remove') {
        this.autoScroll()
      }
    },
  },
  beforeDestroy() {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer)
      this.scrollTimer = null
    }
  },
}
</script>

<style lang="scss" scoped>
.bug-list {
  overflow: auto;
  height: 100%;
  font-size: 14px;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .bug-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px;
    margin-bottom: 6px;
    color: #fff;
    background: #1859627F;
    border: 1px solid #198188;

    &:last-child {
      margin-bottom: 0;
    }

    .bug-left {
      display: flex;

      .bug-title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        width: 45px;
        min-height: 37px;
        font-size: 12px;
        background-size: 100% 100%;
        flex: 0 0 45px;
        background-image: url('../../../assets/images/inspect/alarm-green.png');

        .bug-text {
          width: 35px;
          text-align: center;
          line-height: 16px;
        }
      }

      .bug-desc {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #c7e3ff;
        letter-spacing: 0;
        line-height: 16px;
      }
    }

    .bug-buttom {
      margin: 4px 0;

      .bug-register {
        cursor: pointer;

        .iconfont {
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }

  .bug-item-alarm {
    background: #7417174C;
    border: 1px solid #881919;

    .bug-left {
      .bug-title {
        background-image: url('../../../assets/images/inspect/alarm-red.png');
      }
    }
  }
}
</style>
